import { TransactionStore } from "./transactionTypes"

export function selectTransactionSuccessModal({ transactionState }: TransactionStore) {
    return transactionState.successModal
}
